import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { getProtectedResource } from "../../services/apiRequest.service";
import { NestedResponseData } from "../../models/responseData";
import {
  TransformedData,
  transformDataBarChart
} from "../../utils/transformDataUtils";
import FilterDropdown from "../../components/FilterDropdown";
import DoubleBarChart from "../../charts/doubleBarChart/DoubleBarChart";
import InstitutionN from "../../components/InstitutionN";
import PageLoader from "../../components/PageLoader";
import ApiResponseToCSVConverter from "../../utils/csvDownload/ApiResponseToCsvConverter";
import { determineResponseTypeNestedResponseData } from "../../utils/determineResponseType";

const TypeOfPositions = () => {
  const [selectedFilter, setSelectedFilter] = useState("exit_status");
  const [apiResponse, setApiResponse] = useState<NestedResponseData | null>(null);
  const [transformedResponse, setTransformedResponse] = useState<TransformedData[] | null>(null);
  const [institutionN, setInstitutionN] = useState(0);

  const { getAccessTokenSilently } = useAuth0();
  const { year } = useParams();

  useEffect(() => {

    const getData = async () => {
      const accessToken = await getAccessTokenSilently();
      const requestUrl = `section3/subsection4/?report_year=${year}&group_by=${selectedFilter}`;

      let { data, error } = await getProtectedResource(accessToken, requestUrl);

      if (data && determineResponseTypeNestedResponseData(data)) {
        setApiResponse(data);
        setTransformedResponse(transformDataBarChart(data, "3.4", selectedFilter));
        setInstitutionN(data.institution.total.total);
      }

      if (error) {
        console.error("Error fetching data:", error);
      }
    };

    getData();
  }, [getAccessTokenSilently, selectedFilter, year])
  return (
    <>
      <h2>3.4 Type of positions held by spouses/partners</h2>
      <p>What positions did the spouses/partners of departures and retentions hold at the time of the outside offer?</p>

      {!transformedResponse && <PageLoader />}

      {transformedResponse &&
        <>
          <InstitutionN institutionN={institutionN} />
          <FilterDropdown setSelectedFilter={setSelectedFilter} />
          <DoubleBarChart
            data={transformedResponse}
            selectedFilter={selectedFilter}
            institutionN={institutionN}
          />
          <ApiResponseToCSVConverter
            apiResponse={apiResponse}
            selectedFilter={selectedFilter}
            filename="3.4_Positions"
            section="3.4"
          />
        </>
      }

      
    </>
  )
}

export default TypeOfPositions;